const driversOnline = {
  driversOnline: 'Online Fahrer',

  table: {
    headers: {
      name: 'Name',
      phone: 'Telefonnummer',
      status: 'Status',
      vehicle: 'Fahrzeug',
      activeSince: 'Aktiv seit',
      sum: 'Summe',
      pax: 'Personen',
      earned: 'Verdient',
    },
    driverStatusOptions: {
      online: 'Online',
      enRoute: 'Unterwegs',
      break: 'Pause',
      endBreak: 'Pause beenden',
    },
    actions: {
      deactivate: 'Sperren',
    },
  },

  form: {
    fields: {
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
    },
    activateButton: 'Online gehen',
  },

  deactivateModal: {
    header: 'Fahrer deaktivieren',
    body: 'Möchten Sie {{driver}} wirklich deaktivieren?',
  },
  breakModal: {
    header: 'Pausenfahrer',
    body: 'Möchten Sie {{driver}} wirklich für eine Pause freigeben?',
  },
};

export default driversOnline;
